import logo from './logo.svg';
import './App.css';
import Home from './pages/Home';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { BrowserRouter, Route, Routes } from 'react-router-dom';




import SelectionPage from './pages/Selection';
import ProgressInfo from './pages/ProgressInfo';
import Database from './pages/Database';
import UserLogs from './pages/UserLogs';
import Users from './pages/Users';
import ConfigManagement from './pages/ConfigManagement';
import AuthGuard from './auth/AuthGuard';
import { AuthProvider } from './contexts/JWTAuthContext';
import NotFound from './pages/NotFound';

function App() {
  return (
   <BrowserRouter >
   
     
      
      <Routes >      
      <Route path='/' element={<Home></Home>}></Route>
     
      
      <Route path='/select' element={<AuthGuard><SelectionPage></SelectionPage></AuthGuard>}></Route>
     
      <Route path='/progress' element={<AuthGuard><ProgressInfo></ProgressInfo></AuthGuard>}></Route>
      <Route path='/database' element={<AuthGuard><Database></Database></AuthGuard>}></Route>
      <Route path='/user-logs' element={<AuthGuard><UserLogs></UserLogs></AuthGuard>}></Route>
      <Route path='/users' element={<AuthGuard><Users></Users></AuthGuard>}></Route>
      <Route path='/config' element={<AuthGuard><ConfigManagement></ConfigManagement></AuthGuard>}></Route>
      <Route path='*' element={<NotFound></NotFound>}></Route>
     
      
      </Routes>
    
       <div className='mt-10'><div className="z-50 text-center text-sm  bottom-0 w-full h-5 lg:fixed bg-gradient-to-r from-app_green to-app_blue">
        <span className="text-white text-s">Ver 3.8.0</span>
      </div></div>
   </BrowserRouter>
  );
}

export default App;
